export function mergeUniqueById<T extends {id?: string | number}>(
    current: T[],
    incoming: T[]
): T[] {
    const merged = new Map<string | number, T>();

    current.forEach(item => {
        if (item && item.id !== undefined && item.id !== null) {
            merged.set(item.id, item);
        }
    });
    incoming.forEach(item => {
        if (item && item.id !== undefined && item.id !== null) {
            merged.set(item.id, item);
        }
    });

    return Array.from(merged.values());
}
